/**
 * Os dois sinais do aviso de "parece que este lançamento já existe" (05/10).
 *
 * São marcados por PROPRIEDADE, e não por classe: o build transpila para um
 * alvo em que `instanceof` de uma classe que estende `Error` não é confiável,
 * e um `instanceof` que falha calado faria o aviso virar "não consegui salvar".
 */

/** O servidor achou um lançamento parecido e não gravou. */
export interface DuplicataPossivel extends Error {
  codigo: 'possivel_duplicata';
  /** "Mercado, R$ 50,00, em 04/10" — escrita pelo servidor, dono da frase. */
  frase: string;
}

export const duplicataPossivel = (frase: string): DuplicataPossivel =>
  Object.assign(new Error('Possível duplicata'), { codigo: 'possivel_duplicata' as const, frase });

export const ehDuplicataPossivel = (e: unknown): e is DuplicataPossivel =>
  (e as { codigo?: unknown })?.codigo === 'possivel_duplicata';

/**
 * Ela viu o aviso e escolheu NÃO lançar.
 *
 * É rejeição de propósito: quem chamou (formulário, campo de escrever) precisa
 * saber que nada foi salvo para não limpar o que ela digitou. Mas não é erro —
 * quem trata deve ficar quieto, sem "não consegui salvar".
 */
export interface LancamentoCancelado extends Error {
  codigo: 'lancamento_cancelado';
}

export const lancamentoCancelado = (): LancamentoCancelado =>
  Object.assign(new Error('Lançamento cancelado por ela'), { codigo: 'lancamento_cancelado' as const });

export const ehLancamentoCancelado = (e: unknown): e is LancamentoCancelado =>
  (e as { codigo?: unknown })?.codigo === 'lancamento_cancelado';
